module.exports = __webpack_public_path__ + "img/PS.4f5a0c0a.png";